import { CobuText, CobuStack } from '@cobu/ui';
import SkillInput from './SkillInput';
import { Strings } from '../../constants/Strings';

interface SkillData {
  firstSkill: string;
  secondSkill: string;
  thirdSkill: string;
}

interface SkillsSectionProps {
  likesHelpingWith: SkillData;
  needsHelpWith: SkillData;
  onLikesHelpingWithChange: (field: keyof SkillData, value: string) => void;
  onNeedsHelpWithChange: (field: keyof SkillData, value: string) => void;
}

export default function SkillsSection({
  likesHelpingWith,
  needsHelpWith,
  onLikesHelpingWithChange,
  onNeedsHelpWithChange
}: SkillsSectionProps) {
  const strings = Strings.get();

  return (
    <CobuStack 
      bg="$background" 
      px="$4" 
      py="$0"
      br="$2"
      w="100%"
    >
      <CobuText 
        variant="heading" 
        color="$cobuDarkBlue" 
        fontSize={21}
        fontWeight="bold"
      >
        {strings.profile.components.managePublicProfile.skillsSection.title}
      </CobuText>
      <CobuText 
        variant="body" 
        color="$cobuDarkBlue50" 
        fontSize={14}
        fontWeight="regular"
        mt="$3"
      >
        {strings.profile.components.managePublicProfile.skillsSection.description}
      </CobuText>
      <CobuText 
        variant="body" 
        color="$cobuDarkBlue50" 
        fontSize={14}
        fontWeight="regular"
      >
        {strings.profile.components.managePublicProfile.skillsSection.characterLimit}
      </CobuText>

      {/* Helping Skills */}
      <CobuStack gap="$3">
        <CobuText 
          variant="body" 
          color="$cobuDarkBlue" 
          fontSize={12}
          fontWeight="bold"
          mt="$4"
        >
          {strings.profile.components.managePublicProfile.skillsSection.helpingSkills.title}
        </CobuText>
        
        <CobuStack gap="$2">
          <SkillInput
            taskNumber={1}
            value={likesHelpingWith.firstSkill}
            placeholder={strings.profile.components.managePublicProfile.skillsSection.helpingSkills.placeholders[0]}
            onChangeText={(text) => onLikesHelpingWithChange('firstSkill', text)}
          />
          <SkillInput
            taskNumber={2}
            value={likesHelpingWith.secondSkill}
            placeholder={strings.profile.components.managePublicProfile.skillsSection.helpingSkills.placeholders[1]}
            onChangeText={(text) => onLikesHelpingWithChange('secondSkill', text)}
          />
          <SkillInput
            taskNumber={3}
            value={likesHelpingWith.thirdSkill}
            placeholder={strings.profile.components.managePublicProfile.skillsSection.helpingSkills.placeholders[2]}
            onChangeText={(text) => onLikesHelpingWithChange('thirdSkill', text)}
          />
        </CobuStack>
      </CobuStack>

      {/* Need Help Skills */}
      <CobuStack gap="$3" >
        <CobuText 
          variant="body" 
          color="$cobuDarkBlue" 
          fontSize={12}
          fontWeight="bold"
          mt="$4"
        >
          {strings.profile.components.managePublicProfile.skillsSection.needingHelpSkills.title}
        </CobuText>
        
        <CobuStack gap="$2">
          <SkillInput
            taskNumber={1}
            value={needsHelpWith.firstSkill}
            placeholder={strings.profile.components.managePublicProfile.skillsSection.needingHelpSkills.placeholders[0]}
            onChangeText={(text) => onNeedsHelpWithChange('firstSkill', text)}
          />
          <SkillInput
            taskNumber={2}
            value={needsHelpWith.secondSkill}
            placeholder={strings.profile.components.managePublicProfile.skillsSection.needingHelpSkills.placeholders[1]}
            onChangeText={(text) => onNeedsHelpWithChange('secondSkill', text)}
          />
          <SkillInput
            taskNumber={3}
            value={needsHelpWith.thirdSkill}
            placeholder={strings.profile.components.managePublicProfile.skillsSection.needingHelpSkills.placeholders[2]}
            onChangeText={(text) => onNeedsHelpWithChange('thirdSkill', text)}
          />
        </CobuStack>
      </CobuStack>
    </CobuStack>
  );
} 